import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_WORKSPACE_PREBID_CONFIGURATION: TypedDocumentNode<Data, Variables> = gql`
  query getWorkspacePrebidConfiguration($workspaceId: ID!) {
    workspacePrebidConfiguration(workspaceId: $workspaceId) {
      allowActivitiesData
      auctionDelay
      disablePrebidStackForUsersWithPoorInternetEnabled
      gdprTcfEnabled
      gdprTcfTimeout
      gppControlUsNat
      gppControlUsStates
      gppEnabled
      gppTimeout
      id
      maximumRttToEnablePrebidStack
      prebidTimeout
      s2sTimeoutMultiplier
      usPrivacyCcpaEnabled
      usPrivacyCcpaTimeout
      videoPlayer
    }
  }
`
